export default {
  state: {

  },
  mutations: {

  },
  actions: {
    getArticles(context, { limit = 8, offset = 0, params = '' }) {
      return axios
        .get(`/web-api-2/article/all/${offset}/${limit}/${params}`)
        .then(res => res.data.posts)
        .catch(e => {
          throw new Error(e)
        });
    },
    searchArticles(context, { limit = 8, offset = 0, name = '' }) {
      const form = new FormData()

      form.append('is_posted_reading_room', true)
      form.append('limit', limit)
      form.append('offset', offset)

      if (name) form.append('name', name)

      return axios
        .post('/web-api-2/article/search/', form)
        .then(r => r.data)
    },
    getArticlesByCategory(context, id) {
      return axios
        .get(`/web-api-2/article/category/${id}`)
        .then(res => res.data.posts)
        .catch(e => {
          throw new Error(e)
        });
    },
    async getArticleCategories() {
      return axios
        .get('/web-api-2/article/categories/')
        .then(res => res.data)
        .then(res => res.categories)
        .then(res => {
          return res.reduce((obj, category) => {
              obj[category.code] = category.id
              return obj
            }, {})
        })
        .catch(e => {
          throw new Error(e)
        })
    },
    getArticle(context, link) {
      return axios
        .get(`/web-api-2/article/${link}`)
        .then(r => r.data)
    },
  },
  getters: {

  }
}
